import {
  investorPortalWhiteLabelRoutes,
  managerWhiteLabelSections,
} from "@verivest/shared-components";

export const managerWhiteLabelMenuItems = [
  {
    label: "Overview",
    sectionName: managerWhiteLabelSections.overview,
    url: investorPortalWhiteLabelRoutes.overview,
  },
  {
    label: "Opportunities",
    sectionName: managerWhiteLabelSections.opportunities,
    url: investorPortalWhiteLabelRoutes.opportunities,
  },
  {
    label: "Accounts",
    sectionName: managerWhiteLabelSections.accounts,
    url: investorPortalWhiteLabelRoutes.accounts,
  },
  {
    label: "Investments",
    sectionName: managerWhiteLabelSections.investments,
    url: investorPortalWhiteLabelRoutes.investments,
  },
  {
    label: "Documents",
    sectionName: managerWhiteLabelSections.documents,
    url: investorPortalWhiteLabelRoutes.documents,
  },
  {
    label: "Transactions",
    sectionName: managerWhiteLabelSections.transactions,
    url: investorPortalWhiteLabelRoutes.transactions,
  },
];
